import classNames from "classnames";
import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { IdwFormLabel } from "../idw-form-label/idw-form-label";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { ClickableIcon } from "../clickable-icon/clickable-icon";
import styles from "./label-value-container.less";

type LabelValueContainerProps = {
    label: string;
    value: string;
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    labelIsBold: boolean;
    isRequired?: boolean;
    className?: string;
    afterValueIcon?: IconDefinition;
    afterValueIconDisabled?: boolean;
    afterValueIconOnClick?: () => void;
    afterValueIconContainerMarginLeftAuto?: boolean;
    controlId: string;
};

export const LabelValueContainer = (props: LabelValueContainerProps) => {
    const {
        label,
        value,
        layout,
        labelWidth,
        isRequired,
        labelIsBold,
        className,
        afterValueIcon,
        afterValueIconDisabled,
        afterValueIconOnClick,
        afterValueIconContainerMarginLeftAuto,
        controlId
    } = props;

    const labelValueContainerClassName = useMemo(() => {
        return layout === LayoutTypes.COLUMN ? styles.labelValueContainerColumn : styles.labelValueContainerRow;
    }, [layout]);

    const displayValue = useMemo(() => {
        return value ? value : resources.common.notFound;
    }, [value]);

    const labelClassName = useMemo(() => {
        return labelIsBold ? styles.labelIsBold : "";
    }, [labelIsBold]);

    return (
        <div className={classNames(labelValueContainerClassName, className ? className : "")}>
            {label && (
                <IdwFormLabel className={classNames(styles.labelElement, labelClassName)} isRequired={!!isRequired} label={label} labelWidth={labelWidth} />
            )}
            <IdwFormLabel isRequired={false} label={displayValue} labelWidth={LabelWidthTypes.EXTRA_SMALL} />
            {afterValueIcon && afterValueIconOnClick && (
                <div className={afterValueIconContainerMarginLeftAuto ? styles.marginLeftAuto : ""}>
                    <ClickableIcon controlId={controlId} disabled={afterValueIconDisabled} icon={afterValueIcon} onClick={afterValueIconOnClick} className={styles.afterInputIcon} />
                </div>
            )}
        </div>
    );
};